import I18n from 'app/i18n';
import {ARTICLE_PROMOTION_ARCHIVE_TYPE, ARTICLE_PROMOTION_OLD_TYPE} from 'app/utils/Consts';

export const isArticleNews = function(type: string): boolean {
    if (type === 'news') {
        return true;
    }

    return false;
};

export const isArticlePromotion = function(type: string): boolean {
    if (type === ARTICLE_PROMOTION_OLD_TYPE) {
        return true;
    }

    return false;
};

export const articleHeading = function(type: string): string {
    switch (type) {
    case 'news':
        return I18n.t('news_header');
    case 'promotions':
    case ARTICLE_PROMOTION_ARCHIVE_TYPE:
    case ARTICLE_PROMOTION_OLD_TYPE:
        return I18n.t('promotions_header');
    case 'careers':
        return I18n.t('menu_links.careers');
    case 'hidden_temples':
        return I18n.t('hidden_temples');
    default:
        throw new Error(type);
    }
};
